export default __webpack_public_path__ + "6ea8258399a76892a950e1bdfeb27497.svg";